export enum FiltersTypes {
  setFilters = "[Filters] Met à jour les filtres",
  setTimezoneFilter = "[Filters] Met à jour le fuseau horaire",
  toggleFilterOnline = "[Filters] Change le filtre online",
  toggleFilterPhysical = "[Filters] Change le filtre physique",
  toggleModalFilterMobile = "[Filters] Change l'état de la modal des filtres en mobile'",
  toggleModalHelp = "[Filters] Change l'état de la modal d'aide''",
}

export const setFilters = (filters) => ({
  type: FiltersTypes.setFilters,
  data: filters
})

export const setTimezoneFilter = (timezone) => ({
  type: FiltersTypes.setTimezoneFilter,
  data: timezone
})

export const toggleFilterOnline = () => ({
  type: FiltersTypes.toggleFilterOnline
})

export const toggleFilterPhysical = () => ({
  type: FiltersTypes.toggleFilterPhysical
})

export const toggleModalFilterMobile = () => ({
  type: FiltersTypes.toggleModalFilterMobile
})

export const toggleModalHelp = () => ({
  type: FiltersTypes.toggleModalHelp
})


// WEBPACK FOOTER //
// ./src/app/store/filter/filter.action.ts